import React, { Fragment } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import { useLocation } from "react-router-dom";

import { useResizeDetector } from "react-resize-detector";

import AppMain from "../../Layout/AppMain";
import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import AppFooter from "../../Layout/AppFooter";
import ThemeOptions from "../../Layout/ThemeOptions";
import { setIsDesktop } from "../../reducers/ThemeOptions";

const Main = (props) => {
  const location = useLocation();
  const isLoginRoute = location.pathname === "/login";
  // Note: closedSmallerSidebar state removed as it was unused

  const {
    colorScheme,
    enableFixedHeader,
    enableFixedSidebar,
    enableFixedFooter,
    enableClosedSidebar,
    enableMobileMenu,
    enablePageTabsAlt,
  } = props;

  const { width, ref } = useResizeDetector();
  React.useEffect(() => {
    const isDesktop = (width || 0) >= 992;
    const id = setTimeout(() => props.dispatch(setIsDesktop(isDesktop)), 120);
    return () => clearTimeout(id);
  }, [width]);

  if (isLoginRoute) {
    return (
      <Fragment>
        <div ref={ref}>
          <div className={cx("app-container app-theme-" + colorScheme)}>
            <div className="app-main__outer">
              <div className="app-main__inner">
                <AppMain />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <ThemeOptions />
      <div ref={ref}>
        <div
          className={cx(
            "app-container app-theme-" + colorScheme,
            { "fixed-header": enableFixedHeader },
            { "fixed-sidebar": enableFixedSidebar || width < 992 },
            { "fixed-footer": enableFixedFooter },
            { "closed-sidebar": (width >= 992) ? enableClosedSidebar : false },
            {
              "closed-sidebar-mobile": width < 992,
            },
            { "sidebar-mobile-open": (width < 992) && enableMobileMenu },
            { "body-tabs-shadow-btn": enablePageTabsAlt }
          )}>
          <AppHeader />
          <div className="app-main">
            <AppSidebar />
            <div className="app-main__outer">
              <div className="app-main__inner">
                <AppMain />
              </div>
              <AppFooter />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProp = (state) => ({
  colorScheme: state.ThemeOptions.colorScheme,
  enableFixedHeader: state.ThemeOptions.enableFixedHeader,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableFixedFooter: state.ThemeOptions.enableFixedFooter,
  enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,
});

export default connect(mapStateToProp)(Main);
